import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import ALL_NEWSLETTER_QUERY from '../../../../graphql/AllNewsletter';
import '../../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Banner from '../../../../components/Banner';
import Footer from '../../../../components/Footer';
import Sidebar from '../../../../components/Sidebar';
import { IsAdmin } from '../../../../utils/Roles';


class NewsletterList extends Component {
  componentWillMount() {
    if (!IsAdmin()) {
      this.props.history.push('/login');
    }
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  render() {
    const newsletter = (this.props.newsletter || []).map(n => ({
      name: n.name,
      email: n.email,
      createdAt: moment(n.createdAt).format('DD/MM/YYYY'),
    }));
    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="newsletter" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Listado de suscritos</h1>

                <BootstrapTable
                  data={newsletter || []}
                  striped
                  hover
                  pagination
                >
                  <TableHeaderColumn
                    dataField="name"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Nombre
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    isKey
                    dataField="email"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Correo electrónico
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="createdAt"
                    dataSort
                  >
                    Fecha
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withNewsletter = graphql(ALL_NEWSLETTER_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    newsletter: data.allNewsletter,
  }),
});

export default withNewsletter(NewsletterList);



// WEBPACK FOOTER //
// ./src/containers/Admin/Newsletter/List/index.js